// SignInButton.js
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../msalConfig';


/** Starts Microsoft sign-in with a full-page redirect. */
const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      // Redirect works in Cursor's embedded browser; loginPopup often opens a blank window there.
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <button onClick={handleLogin} className="login-button">
      <svg className="login-ms" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
      Sign in with Microsoft
      <span className="login-arrow" aria-hidden="true">→</span>
    </button>
  );
};


export default SignInButton;
